// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1e-2";
export var blackBorderOnHover = "_1e-7";
export var cell = "_1e-6";
export var cellContainer = "_1e-3";
export var checked = "_1e-8";
export var disabled = "_1e-5";
export var featuredIconCellContainer = "_1e-9";
export var featuredIconTextContainer = "_1e-b";
export var featuredIconWrapper = "_1e-a";
export var noBorder = "_1e-c";
export var orangeSelectedRow = "_4g-3";
export var overflowableText = "_1e-0";
export var overflowableTextContainer = "_1e-1";
export var row = "_1g-0";
export var rowCheckboxCell = "_1e-4";
export var selectableTable = "_4g-2";